import React from 'react';

const Logo = () => (
  <svg
    className="logo"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 930.6 363.6"
  >
    <g id="Layer_1">
      <g>
        <path
          className="logo-fill"
          d="M695.7,216.3l-72.9,0.1c0,0,6.3-5.9,10.1-11.3c3-4.2,3.8-10,3.8-10c-0.1-35.1,0-70.2-0.4-105.3
                c-0.4-17.2-17.8-25.6-20.8-27.4c0,0,69.8-0.1,102,0c14.8,0,29.8,2.8,43.3,9.8c22.7,11.7,25.4,45.3,2.8,60.5
                c-3.1,2.1-16.9,8.4-16.9,8.4c18.3,25.6,50.6,86.7,50.6,86.7s10.7,14.8,16.5,19.4c-0.9,0.2-5.6,0.5-6.7,0.5c-14,0.9-27-0.9-39.2-9
                c-18.3-12.1-32.4-27.8-42.9-46.7c-10-18-30.8-57.5-31.3-58.8c2.1-0.1,32.4,4.3,32-24.8c0.3-11.8-3.9-25.7-17.2-28.8
                c-6.9-1.6-23.6,0-23.6,0s-0.1,97.5,0.4,115c0.2,6.4-0.4,5.1,1.3,11.3c0.7,2.6,3.2,4.9,5,7.1C692.4,214,694.1,215,695.7,216.3z"
        />
        <path
          className="logo-fill"
          d="M602.2,138v103.6c-3.3-5.3-5.8-9.7-8.8-13.8c-11.4-15.1-26.7-19.4-45.1-17c-42.4,15.2-78.4-3.7-78.4-3.7
                c0-1.8,5.2-66.9-15-115.3c4.8-5.9,18.3-47.5,135.2-26.8c-7.1,15.5-14.1,28.7-21.4,44.6c-2.7-4.1-5.1-7.9-7.5-11.7
                c-3.6-5.7-8-10.5-13.9-13.9c-5.4-3.1-11.2-4.7-16.9-4.5c-12.3,0.3-24,8.1-29.1,20.8c-9.5,23.7-10,47.7-1.1,71.6
                c7.6,20.4,26.5,28.5,46.7,20.1c0.9-0.4,1.9-1.7,1.9-2.6c0.1-11.1,0.2-22.3,0-33.4c-0.1-4.9-2.8-8.7-6.5-11.8c-2.4-2.1-5-4-8.1-6.4
                H602.2z"
        />
        <path
          className="logo-fill"
          d="M795.1,216.4c3.4-3.8,8.4-7,10.8-10.4c4.7-6.5,6.1-14.1,6-22c-0.1-31-0.1-62-0.5-93
                c-0.1-9.7-3.8-17.7-13-22.3c-1.9-0.9-5.7-3.7-8.2-5.4c1.8-0.3,140.1,0,140.1,0s0.8,49.1,0,51.5c-1.6-3.7-9.8-35.7-30.5-35.3
                c-12,0.4-40.2,0-40.2,0s-0.3,48.5,0,51c0,0,46.5,0.1,52.1,0.1c-2.8,3.5-22.1,21.3-22.1,21.3c-0.5,0.1-23.6-0.1-30,0
                c0,0,0,30-0.3,41l46.6-0.4c9.9-1.9,19.8-20.4,24.3-29.1c0,9.2,0,53,0,53S797.1,216.5,795.1,216.4z"
        />
        <path className="logo-fill" d="M713.6,296.9c0,0.9,0,1.9,0,3c0-1.4-0.1-2.9-0.2-4.3C713.5,296.1,713.6,296.5,713.6,296.9z" />
        <path
          className="logo-fill"
          d="M564.2,299.8c0,0.1,0,0.1,0,0.2C564.2,299.9,564.2,299.8,564.2,299.8C564.2,299.8,564.2,299.8,564.2,299.8z"
        />
        <path
          className="logo-fill"
          d="M664.5,260.6l18.1,39.3c0,0-7.3,0-10.4,0l-1.6-7.2l-13.6,0l-2,7.2h-8.4c0.5-1.2,2.3-2.8,2.8-3.9
                C654.5,284.2,664.5,260.6,664.5,260.6z M663.7,275.6c-1.1,3.1-4,10.8-4,10.8h8L663.7,275.6z"
        />
        <path
          className="logo-fill"
          d="M494.1,260.8v6.9c-3.3-1-6.4-0.4-9.9-0.6v0c-0.1,0-0.1,0-0.1,0s-0.1,21.4,0.1,29.7c0,0.7,0.2,1.4,0.5,2
                l0.6,1.2H475l0.5-1.3c0.2-0.5,0.3-1.1,0.4-1.7c0.2-8.1,0.1-29.9,0.1-29.9s-0.1,0-0.1,0v0c-3.5,0.2-6.6-0.4-9.9,0.6v-6.9H494.1z"
        />
        <path
          className="logo-fill"
          d="M830.2,263.6c0,1.6,0,36.1,0,36.1L808,274.5l0-0.2c0,2.2,0,20.9,0.1,22.4c0,0.7,0.1,1.4,0.4,2l0.5,1.2h-8.6
                l0.4-1.3c0.2-0.5,0.3-1.1,0.3-1.7c0-1.6-0.2-23,0-33c0-1.3-1.5-3.3-1.5-3.3h7.1l17.4,21.9c0,0,0-17.4,0-18.7c0-0.7-0.1-1.4-0.4-2
                l-0.4-1.2h7.7l-0.4,1.3C830.3,262.5,830.2,263,830.2,263.6z"
        />
        <path
          className="logo-fill"
          d="M531.9,298.6l0.5,1.4h-10.3l0.6-1.3c0.3-0.6,0.5-1.3,0.5-2c0-1.5,0.1-13.6,0.1-13.6h-13.8
                c0,0,0.1,12.1,0.1,13.6c0,0.7,0.2,1.4,0.5,2l0.6,1.2h-10.3l0.5-1.3c0.2-0.5,0.3-1.1,0.4-1.7c0-0.9,0-1.9,0-3.1v-27.1
                c0-1.2,0-2.2,0-3.1c0-0.6-0.1-1.2-0.4-1.7l-0.5-1.3h10.3l-0.6,1.2c-0.3,0.6-0.5,1.1-0.5,1.8c0,1.5,0,12.7,0,12.7s2.4,0,5.3,0h2.9
                c2.9,0,5.3,0,5.3,0s0-11.2,0-12.7c0-0.7-0.2-1.2-0.5-1.8l-0.6-1.2h10.3l-0.5,1.3c-0.2,0.5-0.3,1.2-0.4,1.7c0,0.9,0,1.9,0,3v27.1
                c0,1.2,0,2.2,0,3.1C531.6,297.5,531.7,298,531.9,298.6z"
        />
        <path
          className="logo-fill"
          d="M564.4,291.4l-1.6,8.5c0,0-17.5,0-23.4,0c0,0,1-1.8,1.2-3.1c0-0.3,0.1-0.5,0.1-0.8l0.1-32.4
                c-0.4-1.4-0.9-2.8-1.2-3l23.2,0c0,0-0.8,6-1,7.6c-2-1.7-12.5-1.4-12.5-1.4l-0.1,8.3c0,0,6.3,0,9.6-0.1c0.3,0,0.7-0.1,1-0.2
                l1.3-0.4v8.2l-1.2-0.5c-0.6-0.2-1.3-0.4-2-0.4c-0.2,0-0.4,0-0.6,0c-3.5,0-8,0-8,0l0,11.2l11.7-0.2
                C562.6,292.9,564.4,291.4,564.4,291.4z"
        />
        <path
          className="logo-fill"
          d="M612.5,291.4l-1.6,8.5c0,0-17.5,0-23.4,0c0,0,1-1.8,1.2-3.1c0-0.3,0.1-0.5,0.1-0.8l0.1-32.4
                c-0.4-1.4-0.9-2.8-1.2-3l10.6,0.1c-0.8,0.9-1.3,3-1.3,3v29.2l12.1-0.1C610.8,292.9,612.5,291.4,612.5,291.4z"
        />
        <path
          className="logo-fill"
          d="M642,291.4l-1.6,8.5c0,0-17.5,0-23.4,0c0,0,1-1.8,1.2-3.1c0-0.3,0.1-0.5,0.1-0.8l0.1-32.4
                c-0.4-1.4-0.9-2.8-1.2-3l23.2,0c0,0-0.8,6-1,7.6c-2-1.7-12.5-1.4-12.5-1.4l-0.1,8.3c0,0,6.3,0,9.6-0.1c0.3,0,0.7-0.1,1-0.2
                l1.3-0.4v8.2l-1.2-0.5c-0.6-0.2-1.3-0.4-2-0.4c-0.2,0-0.4,0-0.6,0c-3.5,0-8,0-8,0l0,11.2l11.7-0.2
                C640.2,292.9,642,291.4,642,291.4z"
        />
        <path
          className="logo-fill"
          d="M722.6,280.9l-0.6,1.2c-0.3,0.6-0.4,1.3-0.5,2c0,1.5-0.1,3.5-0.1,5.7c0,0,0,0,0,0c0,3.5,0,6.5,0,6.5
                c-4.2,2.1-9.2,3.7-14.1,3.7c-3.7,0-7.2-1.1-10.4-2.9c-7-4.1-10-10.5-9.7-18.6c0.3-9.4,8.6-17.1,18.3-17.9c3.7-0.3,4.2-0.4,7.9-0.1
                c2.3,0.2,5.9,1.6,7.4,2.2l0,9c-3.6-4.3-7.6-6.5-12.4-6.2c-7.2,0.4-12.8,7.1-12.3,14.8c0.5,8.6,5.2,14.2,13.8,13.9
                c2.7-0.2,3.5-1.1,3.6-3.9v-0.1c0-1,0-2.1,0-3.2v0c0-1.1,0-2.2,0-3c0-0.4-0.1-0.9-0.2-1.3c0,0,0,0,0,0c0-0.1-0.1-0.3-0.1-0.4
                l-0.5-1.3H722.6z"
        />
        <path className="logo-fill" d="M713.7,300c0-1.1,0-2.2,0-3.2C713.7,297.9,713.7,299,713.7,300z" />
        <path
          className="logo-fill"
          d="M761.1,260l-0.5,1.2c-0.3,0.6-0.4,1.3-0.4,2c0,1.5,0,3.5-0.1,5.7h0c0,6.7,0,13.4-0.1,20.1
                c-0.1,5-3,9.1-7.9,10.2c-1.9,0.4-3.9,0.7-5.9,0.7c-2.1,0.1-4.1-0.1-6.1-0.4c-5.6-1.1-8.8-4.9-9.3-10.7c-0.4-4.1-0.2-8.2-0.3-12.3
                c0-2.2,0-4.4,0-6.7v-0.1c0-2.7,0-5.1-0.1-6.8c0-0.6-0.1-1.2-0.4-1.7l-0.5-1.3H740l-0.6,1.2c-0.3,0.6-0.5,1.3-0.5,2
                c0,0.7,0,1.6,0,2.5v0.1c0,6.9-0.1,13.6,0.1,20.4c0.1,5.9,3,8.9,7.9,8.6c3.6-0.2,6.4-2.6,6.4-6.2c0.1-6.6,0.1-13.2,0.1-19.9v-0.2
                c0-2.1,0-4-0.1-5.5c0-0.6-0.1-1.2-0.3-1.7l-0.5-1.3H761.1z"
        />
        <path
          className="logo-fill"
          d="M792.9,291.4l-1.6,8.5c0,0-17.5,0-23.4,0c0,0,1-1.8,1.2-3.1c0-0.3,0.1-0.5,0.1-0.8l0.1-32.4
                c-0.4-1.4-0.9-2.8-1.2-3l23.2,0c0,0-0.8,6-1,7.6c-2-1.7-12.5-1.4-12.5-1.4l-0.1,8.3c0,0,6.3,0,9.6-0.1c0.3,0,0.7-0.1,1-0.2
                l1.3-0.4v8.2l-1.2-0.5c-0.6-0.2-1.3-0.4-2-0.4c-0.2,0-0.4,0-0.6,0c-3.5,0-8,0-8,0l0,11.2l11.7-0.2
                C791.1,292.9,792.9,291.4,792.9,291.4z"
        />
        <path
          className="logo-fill"
          d="M848.6,298.7l0.6,1.2h-10.3l0.5-1.3c0.2-0.5,0.3-1.1,0.4-1.7c0-0.9,0-32.5,0-33.3c0-0.6-0.1-1.2-0.4-1.7
                l-0.5-1.3h10.3l-0.6,1.2c-0.3,0.6-0.5,1.3-0.5,2c0,0.8,0,32.6,0,32.9C848.1,297.4,848.3,298.1,848.6,298.7z"
        />
        <path
          className="logo-fill"
          d="M887.4,263.6c0,1.6,0,36.1,0,36.1l-22.3-25.2l0-0.2c0,2.2,0,20.9,0.1,22.4c0,0.7,0.1,1.4,0.4,2l0.5,1.2h-8.6
                l0.4-1.3c0.2-0.5,0.3-1.1,0.3-1.7c0-1.6-0.2-23,0-33c0-1.3-1.5-3.3-1.5-3.3h7.1l17.4,21.9c0,0,0-17.4,0-18.7c0-0.7-0.1-1.4-0.4-2
                l-0.4-1.2h7.7l-0.4,1.3C887.5,262.5,887.4,263,887.4,263.6z"
        />
        <path
          className="logo-fill"
          d="M930.6,280.9l-0.6,1.2c-0.3,0.6-0.4,1.3-0.5,2c0,1.5-0.1,3.5-0.1,5.7c0,0,0,0,0,0c0,3.5,0,6.5,0,6.5
                c-4.2,2.1-9.2,3.7-14.1,3.7c-3.7,0-7.2-1.1-10.4-2.9c-7-4.1-10-10.5-9.7-18.6c0.3-9.4,8.6-17.1,18.3-17.9c3.7-0.3,4.2-0.4,7.9-0.1
                c2.3,0.2,5.9,1.6,7.4,2.2l0,9c-3.6-4.3-7.6-6.5-12.4-6.2c-7.2,0.4-12.8,7.1-12.3,14.8c0.5,8.6,5.2,14.2,13.8,13.9
                c2.7-0.2,3.5-1.1,3.6-3.9v-0.1c0-1,0-2.1,0-3.2v0c0-1.1,0-2.2,0-3c0-0.4-0.1-0.9-0.2-1.3c0,0,0,0,0,0c0-0.1-0.1-0.3-0.1-0.4
                l-0.5-1.3H930.6z"
        />
        <g>
          <path
            className="logo-fill mtg-icon"
            d="M183.7,186.5c-2,0.9-4.1,1.7-6.1,2.6c-23,10.4-40.9,26.7-54.8,47.6c-11.4,17.2-18.6,36.1-23.2,56.1
                    c-3.2,13.9-4.9,27.9-6.1,42.1c-0.2,2.9-0.5,5.9-0.9,8.8c-0.1,0.9-0.4,1.8-0.7,2.7c-0.2,0-0.4,0-0.6,0c-0.2-0.9-0.6-1.9-0.7-2.8
                    c-0.7-6.7-1.2-13.4-1.9-20.2c-2.4-22.4-6.9-44.3-16.2-64.9c-10.1-22.4-24.5-41.5-44.4-56.3c-8.4-6.2-17.4-11.2-27.2-15
                    c-0.9-0.4-1.2-0.8-1.1-1.8c1.2-14.3,2.2-28.7,3.5-43c1.5-17,3.3-34,4.9-51c0.2-1.6,0.5-3.1,0.8-4.7c0.1,0,0.3,0,0.4,0
                    c0.2,1.1,0.6,2.2,0.7,3.3c1.2,9.1,2.4,18.1,3.6,27.2c1.8,14.3,3.6,28.5,7.5,42.4c0.7,2.6,1.7,5.2,2.5,7.8c3.5-1.2,6.8-2.3,10-3.5
                    c0.4-0.2,0.8-0.8,1-1.4c1.5-6,3.2-11.9,4.4-17.9c3.3-17.2,5.1-34.5,6.9-51.9c1.5-13.9,2.9-27.8,4.4-41.6c0.1-0.6,0.2-1.2,0.6-1.8
                    c0.2,2,0.5,3.9,0.7,5.9c1.6,16.8,3.1,33.6,4.8,50.3c1.6,15.3,3.2,30.7,6.3,45.8c0.4,1.8,1,3.6,1.4,5.5c0.2,0.9,0.7,1.1,1.6,1
                    c3-0.3,5.9-0.6,8.9-0.8c1-0.1,1.4-0.4,1.6-1.3c1.6-7.5,3.6-15,4.9-22.6c3.2-18.7,4.6-37.6,5.8-56.6c1.1-16.4,2-32.7,3.1-49.1
                    c0.2-3,0.7-5.9,1-8.9c0.1-0.4,0.2-0.9,0.6-1.3c0.2,0.9,0.5,1.9,0.5,2.8c0.7,8.1,1.3,16.3,1.9,24.4c1.6,21.9,3,43.9,4.8,65.8
                    c1.2,14.3,3.3,28.6,7,42.5c0.4,1.3,0.5,3.1,1.3,3.8c0.9,0.7,2.6,0.5,3.9,0.6c2,0.2,3.9,0.3,5.9,0.6c1.1,0.2,1.6-0.2,1.8-1.3
                    c1.2-5.8,2.8-11.5,3.5-17.4c2.3-19,4.4-37.9,6.4-56.9c1.1-10.5,2-20.9,3-31.4c0-0.5,0.2-1,0.3-1.5c0.1,0,0.2,0,0.4,0
                    c0.4,3.5,0.9,7.1,1.3,10.6c2.3,21.2,4.5,42.4,7,63.5c1.4,12,3.4,23.9,6.5,35.6c0.9,3.3,2.2,5.4,5.8,6c2.1,0.4,4,1.4,6.2,2.2
                    c0.6-1.5,1.1-3,1.6-4.4c2.9-9.1,4.7-18.4,6-27.8c1.9-13.4,3.5-26.9,5.3-40.3c0.4-2.7,0.9-5.4,1.4-8.1c0.2,0,0.3,0,0.5,0
                    c0.2,1,0.5,1.9,0.6,2.9c1,9.2,2.2,18.3,3,27.5c1.8,20.6,3.5,41.2,5.2,61.8c0.2,2.2,0.4,4.4,0.6,6.5
                    C183.7,185.8,183.7,186.1,183.7,186.5z"
          />
        </g>
        <g>
          <path
            className="logo-fill"
            d="M440.8,175.8c-0.3-18.8-2.4-34.1-5.8-46.7c0-0.1,0-0.1,0-0.2c-15.2-53.6-58.7-84.7-111.8-84.7
                    c-66.3,0-116,48.5-116,128.9v17.3c0,80.3,49.6,128.9,116,128.9c53.1,0,96.6-31.1,111.8-84.7c0-0.1,0-0.1,0-0.2
                    c3.3-12.6,5.5-27.9,5.8-46.7C440.8,185.8,440.8,177.8,440.8,175.8z M365.1,181.8c-2,66.4-30.5,92-44.4,92
                    c-14,0-41.4-25.6-43.4-92c2-66.4,29.5-102.3,43.4-102.2C334.6,79.5,363.1,115.4,365.1,181.8z"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default Logo;
